var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoneSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "done-success",
    clipPath: "url(#clip0_2243_626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.44436 8.72535L5.89621 10.7858C5.95129 10.8681 6.02521 10.936 6.11183 10.9839C6.19845 11.0318 6.29526 11.0584 6.39421 11.0613C6.49316 11.0643 6.59139 11.0436 6.68072 11.0009C6.77004 10.9582 6.84789 10.8948 6.90777 10.816L11.5555 4.93572M1.33325 8.00001C1.33325 9.76812 2.03563 11.4638 3.28587 12.7141C4.53612 13.9643 6.23181 14.6667 7.99992 14.6667C9.76803 14.6667 11.4637 13.9643 12.714 12.7141C13.9642 11.4638 14.6666 9.76812 14.6666 8.00001C14.6666 6.2319 13.9642 4.53621 12.714 3.28597C11.4637 2.03572 9.76803 1.33334 7.99992 1.33334C6.23181 1.33334 4.53612 2.03572 3.28587 3.28597C2.03563 4.53621 1.33325 6.2319 1.33325 8.00001Z",
    stroke: "#039855",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2243_626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneSuccess);
export default __webpack_public_path__ + "static/media/done-success.3cbaa7ca964284d4bcf6df7ac1f225f9.svg";
export { ForwardRef as ReactComponent };